import { Dispatch, SetStateAction } from 'react'
import { Button, Typography } from '@mui/material'

import { useStyles } from '../user-profile/change-password-modal/styles'
import { useStyles as useStyles2 } from './styles'
import { EModalState } from './constants'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  requestPrivateKey: () => void
  isRequesting: boolean
  changeModalState: Dispatch<SetStateAction<EModalState>>
}

const RequestPrivateKeyForm = ({ requestPrivateKey, isRequesting, changeModalState }: IProps) => {
  const classes = useStyles()
  const classes2 = useStyles2()

  const handleModalStateChange = () => {
    changeModalState(EModalState.Verification)
  }

  return (
    <div className={classes2.requestFormWrapper}>
      <div className={classes.formInputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="expose-pk-form-title" ns={ETranslationNs.UserProfile} />
        </Typography>
      </div>
      <div className={classes.bottomButtonsWrapper}>
        <Button
          variant="contained"
          type="button"
          disabled={isRequesting}
          onClick={requestPrivateKey}
        >
          <HelperWrapper t="expose-pk-form-submit-button" ns={ETranslationNs.UserProfile} />
        </Button>
        <Button onClick={handleModalStateChange} size="small">
          <HelperWrapper t="expose-pk-form-verification-button" ns={ETranslationNs.UserProfile} />
        </Button>
      </div>
    </div>
  )
}

export { RequestPrivateKeyForm }
